import { connect } from 'react-redux';
import { useProperty } from '@eti/providers';
import { css } from '@eti/styles';
import { Notice, Text, textVariants } from '@etg/wings';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import { getSelected } from '../../single-choice/utils/selection';
import { PLATINUM_SERVICE } from '../../products';
import { ProductCardLayoutType } from '../../common/models/product';
import { standardGrid } from '../../common/main-layout/illustration/styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = PLATINUM_SERVICE;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POST_BOOKING_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  persuasionContent: 'platinumPersuasionContent',
  readMoreContent: 'platinumReadMoreModalContent',
  title: 'platinumTitle',
  priceLabel: 'Products.Price.Label.Only',
  promotionalText: 'platinumPromotionalText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'platinumAbstract',
    additionalInformation: 'platinumAdditionalInformation',
    upSell: 'platinumUpSellText'
  },
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'platinumAbstractSmallCard',
    upSell: 'platinumUpSellTextSmallCard'
  },
  [POST_BOOKING_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'platinumAbstract',
    additionalInformation: 'platinumAdditionalInformation',
    priceLabel: 'Products.Price.Label.Total'
  }
};
const promotionalTextStyle = css`
  margin-top: 16px;
`;
const customGrid = css`
  ${standardGrid}

  .canvas {
    [dir='rtl'] & {
      transform: unset;
    }
  }
`;
const Platinum = _ref => {
  let {
    form,
    layoutType = ProductCardLayoutType.Main,
    isSelected,
    order,
    productPosition,
    sellSpecification,
    className
  } = _ref;
  const {
    p
  } = useProperty();
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement,
    translation: {
      promotionalText,
      priceLabel
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    sellSpecification,
    texts
  });
  const isPlatinumEnabled = p('IbeClient.Platinum.Enabled');
  if (!isPlatinumEnabled || !productData) {
    return null;
  }
  const isSmallLayout = layoutType === ProductCardLayoutType.Small;
  const PromotionalText = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: promotionalText && /*#__PURE__*/_jsx(Notice, {
        className: !isSmallLayout ? promotionalTextStyle : '',
        variant: "promotional",
        children: /*#__PURE__*/_jsx(Text, {
          asHtml: true,
          variant: textVariants._14_BOLD,
          children: promotionalText
        })
      })
    });
  };
  switch (layoutType) {
    case POST_BOOKING_LAYOUT:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: {
          ...productData,
          priceLabel
        },
        ref: rootElement,
        children: /*#__PURE__*/_jsx(ProductLayout.Body, {
          children: /*#__PURE__*/_jsx(PromotionalText, {})
        })
      });
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: productData,
        ref: rootElement,
        children: /*#__PURE__*/_jsx(NewSmallCardLayout.Body, {
          children: /*#__PURE__*/_jsx(PromotionalText, {})
        })
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsxs(ProductLayout, {
        productData: productData,
        ref: rootElement,
        children: [/*#__PURE__*/_jsx(ProductLayout.Illustration, {
          customGrid: customGrid
        }), /*#__PURE__*/_jsx(ProductLayout.Body, {
          children: /*#__PURE__*/_jsx(PromotionalText, {})
        })]
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  const productName = PLATINUM_SERVICE.name;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
export default connect(mapStateToProps)(Platinum);
//# sourceMappingURL=Platinum.js.map